import React from 'react';
import { DateUtil } from '@aperza/util';
export const renderDateWithProps = ({ value, format, needTimezoneConvert = true, timezoneId = 'Asia/Tokyo', emptyValue = '-', stackTime, }) => {
    if (!value)
        return emptyValue;
    const date = DateUtil.parse(value);
    if (!date)
        return emptyValue;
    const _format = format || (stackTime ? 'YYYY/MM/DD[\n]HH:mm' : 'YYYY/MM/DD HH:mm');
    if (needTimezoneConvert) {
        return DateUtil.formatUTC(date, timezoneId, _format);
    }
    return DateUtil.formatUTC(date, 'UTC', _format);
};
/**
 * Display timestamp (date and time) in a specific timezone.
 *
 * If props are not defined, it will show an empty string.
 */
export const AcTimestamp = (props) => {
    return React.createElement("span", { style: { whiteSpace: 'pre' } }, renderDateWithProps(props));
};
export const renderDate = (value, props) => {
    const _props = props || AcTimestamp.defaultProps;
    return renderDateWithProps({ ..._props, value });
};
AcTimestamp.displayName = 'AcTimestamp';
